import StoreIcon from "../mixins/store-icon";
import { zIndexMap } from "@/data/map-markers";
import KBaseMapMarker from "@/components/Maps/KBaseMapMarker";
import KBaseMapInfoWindow from "@/components/Maps/KBaseMapInfoWindow";
import {
	VCard,
	VIcon,
	VList,
	VListItem,
	VListItemAction,
	VListItemContent,
	VListItemTitle
} from "vuetify/lib";

export default {
	name: "KStoreMarker",

	props: { store: Object },

	mixins: [ StoreIcon ],

	computed: {
		zIndex() {
			return zIndexMap.store;
		}
	},

	render() {
		return <KBaseMapMarker
			icon={this.markerIcon}
			lat={this.store.location.lat}
			lng={this.store.location.lng}
			markerId={this.store.address}
			markerType="store"
			title={this.store.name}
			zIndex={this.zIndex}
			scopedSlots={{
				active: () => <KBaseMapInfoWindow autoPan offsetY={-10} showPano>
					<VCard flat light>
						<VList class="list--auto-height" dense>
							<VListItem>
								<VListItemAction>
									<VIcon>store</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{this.store.name}
									</VListItemTitle>
								</VListItemContent>
							</VListItem>

							<VListItem>
								<VListItemAction>
									<VIcon>place</VIcon>
								</VListItemAction>

								<VListItemContent>
									<VListItemTitle>
										{this.store.address}
									</VListItemTitle>
								</VListItemContent>
							</VListItem>
						</VList>
					</VCard>
				</KBaseMapInfoWindow>
			}}
		></KBaseMapMarker>;
	}
};
